/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками RTSP
 */

/**
 * Сервис управления настройками RTSP
 */
export class RtspServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения настроек RTSP
   */
  GetRtsp = (req?: GetRtspRequestDto, init?: RequestInit): Promise<GetRtspResponseDto> => {
    return fm.request<GetRtspRequestDto, GetRtspResponseDto>(`${this.host}/device/api/v1/rtsp${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод редактирования настроек RTSP
   */
  SaveRtsp = (req: SaveRtspRequestDto, init?: RequestInit): Promise<SaveRtspResponseDto> => {
    return fm.request<SaveRtspRequestDto, SaveRtspResponseDto>(`${this.host}/device/api/v1/rtsp`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос получения настроек RTSP
 */
export type GetRtspRequestDto = {
}
/**
 * Ответ на запрос получения настроек RTSP
 */
export type GetRtspResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки RTSP
   */
  readonly data: RtspResponseDto
}>
/**
 * Настройки RTSP
 */
export type RtspRequestDto = {
  /**
   * Флаг включения RTSP сервера
   */
  isRtspServerOn: boolean
}
/**
 * Настройки RTSP
 */
export type RtspResponseDto = {
  /**
   * Флаг включения RTSP сервера
   */
  isRtspServerOn: boolean
}
/**
 * Запрос редактирования настроек RTSP
 */
export type SaveRtspRequestDto = {
  /**
   * Настройки RTSP
   */
  data: RtspRequestDto
}
/**
 * Ответ на запрос редактирования настроек RTSP
 */
export type SaveRtspResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки RTSP
   */
  readonly data: RtspResponseDto
  /**
   * Ошибка
   */
  readonly error: SaveRtspResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type SaveRtspResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveRtspResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения настроек RTSP
   */
  "GetRtspRequest": {
    "kind": "class",
    "text": "Запрос получения настроек RTSP",
  },
  /**
   * Ответ на запрос получения настроек RTSP
   */
  "GetRtspResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек RTSP",
    "fields": {
      /**
       * Настройки RTSP
       */
      "data": {
        "type": "Rtsp",
        "text": "Настройки RTSP",
      },
    },
  },
  /**
   * Настройки RTSP
   */
  "Rtsp": {
    "kind": "class",
    "text": "Настройки RTSP",
    "fields": {
      /**
       * Флаг включения RTSP сервера
       */
      "isRtspServerOn": {
        "type": "bool",
        "text": "Флаг включения RTSP сервера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос редактирования настроек RTSP
   */
  "SaveRtspRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек RTSP",
    "fields": {
      /**
       * Настройки RTSP
       */
      "data": {
        "type": "Rtsp",
        "text": "Настройки RTSP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек RTSP
   */
  "SaveRtspResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек RTSP",
    "fields": {
      /**
       * Настройки RTSP
       */
      "data": {
        "type": "Rtsp",
        "text": "Настройки RTSP",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "SaveRtspResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveRtspResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
}